import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.link.js";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web/common/localization";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { Anchor } from "@faire/web/ui/LinkAnchor";
import React from "react";
import styled from "styled-components";
import { faireLinks } from "./footerContent";
export var FaireLinks = function FaireLinks() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  return /*#__PURE__*/React.createElement(React.Fragment, null, faireLinks(strictLocalize).map(function (section, index) {
    return /*#__PURE__*/React.createElement(FaireLinksGroup, {
      key: index
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "paragraphSansMedium"
    }, section.title), /*#__PURE__*/React.createElement(Spacer, {
      size: 12
    }), section.links.map(function (link, index) {
      return /*#__PURE__*/React.createElement(VerticalLink, {
        key: link.path,
        index: index,
        link: link
      });
    }));
  }));
};
var VerticalLink = function VerticalLink(_ref) {
  var index = _ref.index,
    link = _ref.link;
  return /*#__PURE__*/React.createElement(React.Fragment, null, index === 0 ? null : /*#__PURE__*/React.createElement(Spacer, {
    height: 4
  }), /*#__PURE__*/React.createElement(FaireLink, {
    href: link.path,
    target: link.target
  }, /*#__PURE__*/React.createElement(Typography, null, link.text)));
};
var FaireLinksGroup = styled.div.withConfig({
  displayName: "FaireLinks__FaireLinksGroup"
})(["margin-bottom:24px;", "{padding-bottom:", ";border-bottom:1px solid ", ";margin-bottom:", ";&:last-child{margin-bottom:0;}}", "{margin-bottom:0px;& + &{margin-left:40px;}}", "{& + &{margin-left:56px;}}"], responsiveMediaQueries.mobile, getSpacing("2x"), Core.border.muted, getSpacing("2x"), responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.desktopAndAbove);
var FaireLink = styled(Anchor).withConfig({
  displayName: "FaireLinks__FaireLink"
})(["display:block;margin-bottom:", ";&:hover > p{color:", ";}"], getSpacing(2), Core.text.hover);